import MvCarouselPics from "./_MvCarouselPics";
import MvCarouselTitles from "./_MvCarouselTitles";
import MvCarouselProgress from "./_MvCarouselProgress";

const Mv = () => {
  
  window.addEventListener('autoplayStart', () => {
    mvCarouselProgress.transitionEnd();
  });

  window.addEventListener('slideChange', () => {
    mvCarouselTitles.goto(mvCarouselPics.currentSlide);
    //mvCarouselProgress.update(mvCarouselPics.currentSlide);
  });

  window.addEventListener('progressComplete', () => {
    mvCarouselPics.next();
  });

  window.addEventListener('transitionStart', () => {
    //mvCarouselProgress.stopCountFrame();
    mvCarouselProgress.transitionStart();
  });

  window.addEventListener('transitionEnd', () => {
    //mvCarouselProgress.startCountFrame();
    mvCarouselProgress.transitionEnd();
  });

  const autoplayDuration = 7000;

  const mvCarouselProgress = new MvCarouselProgress(autoplayDuration);
  const mvCarouselPics = new MvCarouselPics(autoplayDuration);
  const mvCarouselTitles = new MvCarouselTitles();

  

  
}

export default Mv;